export function toPlanningNumber(value) {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : 0;
}

export function roundPlanningNumber(value) {
    return parseFloat(toPlanningNumber(value).toFixed(4));
}

export function normalizeMaterialKey(value) {
    return String(value || '').trim().toUpperCase();
}

export function buildPurchaseQuantityMap(purchaseRows = []) {
    return (purchaseRows || []).reduce((map, row) => {
        const materialKey = normalizeMaterialKey(row.material);
        if (!materialKey) return map;
        map[materialKey] = roundPlanningNumber(toPlanningNumber(row.purchase));
        return map;
    }, {});
}

export function applyClearToBuildInventoryCalculations({ item, purchaseQuantityMap = {}, demandQty }) {
    const goodParts = toPlanningNumber(item.goodParts);
    const purchase = toPlanningNumber(purchaseQuantityMap[normalizeMaterialKey(item.material)]);
    const onHold = toPlanningNumber(item.onHold);
    const bookedQty = toPlanningNumber(item.bookedQty ?? item.reservedQty);
    const usage = toPlanningNumber(item.usage);
    const demand = toPlanningNumber(demandQty);
    const totalInv = roundPlanningNumber(goodParts + purchase - onHold - bookedQty);
    const qtyNeeded = roundPlanningNumber(demand * usage);
    const availableQty = roundPlanningNumber(totalInv - qtyNeeded);

    return {
        ...item,
        goodParts,
        purchase,
        onHold,
        bookedQty,
        totalGoodInventory: totalInv,
        qtyNeeded,
        demand,
        availableQty,
    };
}
